"use client";

import { Menu, X } from "lucide-react";
import { useState } from "react";
import { NavLinks } from "./nav-links";

export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className='md:hidden'>
        {/* Toggle Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className='relative z-50 p-2 text-secondary hover:text-primary transition-colors'
          aria-label='Toggle menu'>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Side Menu */}
        <div
          className={`fixed inset-y-0 right-0 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-[70] ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}>
          <div className='p-6'>
            <button
              onClick={() => setIsOpen(false)}
              className='absolute top-4 right-4 p-2 text-secondary hover:text-primary transition-colors'
              aria-label='Close menu'>
              <X size={24} />
            </button>

            <div className='mt-8'>
              <NavLinks mobile />
            </div>

            <div className='mt-8 space-y-4'>
              <a
                href='tel:+27832678013'
                className='block text-secondary hover:text-primary transition-colors'>
                +27832678013
              </a>
              <a
                href='/contact'
                className='block w-full bg-primary hover:bg-primary/90 text-white px-6 py-2.5 rounded-md transition-colors font-medium text-center'>
                Get Care Now
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className='fixed inset-0 bg-black/20 z-[60] md:hidden'
          onClick={() => setIsOpen(false)}
          aria-hidden='true'
        />
      )}
    </>
  );
}
